import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasBackToAssetDismissed.meta';

export type UseTrackCanvasBackToAssetDismissedParams = {
  canvas_id?: string;
};

export const useTrackCanvasBackToAssetDismissed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasBackToAssetDismissed = useCallback(
    (params: UseTrackCanvasBackToAssetDismissedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasBackToAssetDismissed };
};
